import { Component, inject, input } from '@angular/core';

import { BaseDeleteButtonComponent } from '../../../../../shared/base-classes/base-delete-button.component';
import { UltraMenuItemComponent } from '../../../../../shared/components/ultramarine-ui/ultra-menu-item/ultra-menu-item.component';
import { UltraMenuItemWrapperComponent } from '../../../../../shared/components/ultramarine-ui/ultra-menu-item-wrapper/ultra-menu-item-wrapper.component';
import { DialogsService } from '../../../../../shared/services/dialogs.service';
import { VehicleRoadTaxesService } from '../../vehicle-road-taxes.service';

@Component({
	selector: 'app-vehicle-road-tax-delete-button',
	templateUrl: 'vehicle-road-tax-delete-button.component.html',
	imports: [UltraMenuItemWrapperComponent, UltraMenuItemComponent],
})
export class VehicleRoadTaxDeleteButtonComponent extends BaseDeleteButtonComponent {
	private _vehicleRoadTaxesService = inject(VehicleRoadTaxesService);
	private _dialogsService = inject(DialogsService);

	code = input<string>();

	onDelete() {
		this._dialogsService.openDeleteRecordDialog(
			{
				confirmed: () => {
					this._vehicleRoadTaxesService
						.deleteRecord(this.id())
						.subscribe((res) => {
							this.onDeleteCalled.emit(res);
						});
				},
			},
			this.code(),
		);
	}
}
